<template>
  <div >
    <b-navbar toggleable="lg" type="dark" variant="primary"  >
            <b-navbar-brand href="#">
                <b-icon   icon="person-square"></b-icon> ລາຍງານ </b-navbar-brand>
                 <b-navbar-nav class="ml-auto">
                 <!-- <b-nav-item-dropdown right>
                           
                            <template #button-content>
                                ພາສາ
                            </template>
                        <b-dropdown-item href="#">LA</b-dropdown-item>
                        <b-dropdown-item href="#">EN</b-dropdown-item>
                    </b-nav-item-dropdown>   -->

                <b-nav-item @click="goback()" > 
                    <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    <div>
       
      <div id="viewer"></div>
     
    </div>
  </div>
</template>

<script>
 
export default {
  methods: {
      goback() {
            this.$router.go(-1)
        },

  },
  name: 'app',
  data () {
    return {
      params: JSON.parse( this.$route.query.data)
    }
  },
  mounted: function() {
    //console.log( window.Stimulsoft)
  //  window.Stimulsoft.Base.StiLicense.loadFromFile('license.key')
   // window.Stimulsoft.Base.StiLicense.loadFromFile("license.key"); 
   // console.log('Loading Viewer view');
    
   // console.log('Creating the report viewer with default options');
    var viewer = new window.Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false);

   // console.log('Creating a new report instance');
    
    var report = new window.Stimulsoft.Report.StiReport();

 //   console.log('Load report from url');
    report.loadFile('/reports/rpt_visabroken.mrt');

    var dataSet = new window.Stimulsoft.System.Data.DataSet("RECORDS");
    var param= "?fromdate="+this.params.fromdate+"&todate="+this.params.todate+"&prov_id="+this.params.prov_id+"&border_id="+this.params.border_id+""
    dataSet.readJsonFile('http://localhost:3000/visa_brokens'+param,this.params);//one JSON object

    //this line of code added,too.
    report.dictionary.databases.clear();
    report.regData("RECORDS", "RECORDS", dataSet);

//this line of code is also required.
    report.dictionary.synchronize();

  //  console.log('Assigning report to the viewer, the report will be built automatically after rendering the viewer');
    viewer.report = report;

   // console.log('Rendering the viewer to selected element');
    viewer.renderHtml('viewer');

  //  console.log('Loading completed successfully!');

  }
}
</script>

<style>

</style>
